import React from 'react';
import PropTypes from 'prop-types';
import { InformationRevealPanel } from 'web-ui-components/lib/layout/content';
import { StandardBody, SmallestBody } from 'web-ui-components/lib/typography/body';
import { DataTable } from 'web-ui-components/lib/molecules/tables';

export const RevealPanelWithTable = ({ panelHeader, panelSubHeader, columns, data, parserErrorMsg }) => (
	<InformationRevealPanel isOpen title={panelHeader}>
		<StandardBody isFlush>
			{panelSubHeader && <p>{panelSubHeader}</p>}
			{parserErrorMsg && <p>{parserErrorMsg}</p>}
			<SmallestBody>
				<DataTable columns={columns} data={data} keyPath={['id']} isBasic />
			</SmallestBody>
		</StandardBody>
	</InformationRevealPanel>
);

RevealPanelWithTable.propTypes = {
	panelHeader: PropTypes.string.isRequired,
	panelSubHeader: PropTypes.string.isRequired,
	data: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
	columns: PropTypes.arrayOf(PropTypes.string).isRequired,
	parserErrorMsg: PropTypes.string.isRequired,
};
